import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { MqttIngestStatus } from "@opus-dt/shared-types";

export type { MqttIngestStatus } from "@opus-dt/shared-types";

/**
 * Status da ingestão MQTT — alimenta o banner global de
 * degradação no AppLayout. Polling 15s (exige reflexo ≤60s); endpoint
 * informativo sempre responde 200 com o estado no body. Query compartilhada
 * por queryKey fixa — o intervalo é decisão única, não knob por caller.
 */
export function useMqttIngestStatus() {
  return useQuery<MqttIngestStatus>({
    queryKey: ["system", "mqtt-status"],
    queryFn: () => api.get<MqttIngestStatus>("/api/v1/system/mqtt-status"),
    refetchInterval: 15_000,
  });
}
